<div class="container-fluid">



    <div class="card border-0 no-shadow mb-3">
        <div class="card-header text-white">
            Upload Result
        </div>
        <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="large" color="#fff" type="ball-spin-clockwise"
            [fullScreen]="true">
        </ngx-spinner>
        <div class="card-body">
            <form [formGroup]="formContainerUpload">
                <div class="row">
                    <div class="col-sm-10">
                        <div class="form-row ">

                            <div class="form-group col-sm-4 col-md-4 col-lg-3">
                                <label>Tray
                                </label>
                                <input class="form-control" placeholder="Tray" type="text" readonly
                                    formControlName="tray"
                                    [class.invalid]="!formContainerUpload.controls['tray'].valid && formContainerUpload.controls['tray'].touched">
                                <div
                                    *ngIf="!formContainerUpload.controls['tray'].valid && (formContainerUpload.controls['tray'].touched || isSubmitted)">
                                    <div class="invalid-feedback">Please enter Tray</div>
                                </div>

                            </div>




                            <div class="form-group col-sm-8 col-md-6 col-lg-4">

                                <label>No. Of Samples
                                </label>

                                <input class="form-control" placeholder="noOfSamples" readonly type="text"
                                    formControlName="noOfSamples"
                                    [class.invalid]="!formContainerUpload.controls['noOfSamples'].valid && formContainerUpload.controls['noOfSamples'].touched">


                                <div
                                    *ngIf="!formContainerUpload.controls['noOfSamples'].valid && (formContainerUpload.controls['noOfSamples'].touched || isSubmitted)">
                                    <div class="invalid-feedback">Please No Of Samples</div>
                                </div>

                            </div>


                        </div>

                            <div *ngIf="file && file.name && radioForm.value.batchProcess === 'Automatic'">{{file.name}}
                            </div>
                            <div *ngIf="showFileUploadError">
                                No records found in the file uploaded
                            </div>
                            <div class="form-row ">


                                <div class="form-group col-sm-9 col-md-7 col-lg-5" style="position: relative;">
                                    <i class="fa fa-trash fa-lg fa-fw delete-icon" (click)="deleteFile()"></i>
                                    <i class="fa fa-info download-icon" title="Download Sample File" aria-hidden="true"
                                        (click)="downloadFile()"></i>

                                    <label class="uploader items" ondragover="false;" [class.loaded]="loaded"
                                        [style.outlineColor]="dragging ? activeColor : baseColor"
                                        (dragenter)="handleDragEnter()" (dragleave)="handleDragLeave()"
                                        (drop)="handleDrop($event)">
                                        <div class="row " *ngIf="!loaded">
                                            <div class="col upload-file-text ">
                                                <p>Upload file</p>
                                            </div>
                                            <div class="col ">
                                                <i class="fa fa-upload fa-lg fa-fw"></i>
                                            </div>
                                        </div>
                                        <h6 *ngIf="loaded">{{filename}}</h6>
                                        <input type="file" name="file"
                                            accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                            (change)="handleInputChange($event)">
                                    </label>
                                </div>
                            </div>





                            <div class="form-row mt-3">

                                <div class="form-group col-sm-9 col-md-12 col-lg-12">
                                    <div class="text-center">
                                        <button class="btn btn-lg mr-2 submit-button" (click)="onSubmit()"
                                            [disabled]="arraylist.length === 0">Submit</button>

                                        <button class="btn btn-lg mr-2 cancel-button" >Cancel</button>



                                    </div>
                                </div>
                            </div>




                        </div>



                    </div>

            </form>



        </div>

    </div>


</div>